import React, { PropsWithChildren } from 'react';
import { makeStyles } from 'tss-react/mui';
import { SnackbarProvider } from 'notistack';
import { CssBaseDecorator } from '../cssbasedecorator';

import './layout.scss';

const typographyOverride = {
  DefaultFontSize: 12,
};

const dimensionsOverride = {
  DefaultGridSpacing: 1,
  ThemeSpacingUnit: 4,
};

const useStyles = makeStyles()(() =>
  ({
    embeddedContent: {
      padding: `${dimensionsOverride.ThemeSpacingUnit * 2}px`,
    },
  })
);

export function WorklistEmbeddedLayout(props: PropsWithChildren<{}>) {
  const { children } = props;
  const { classes } = useStyles();

  return (
    <CssBaseDecorator overrides={{ dimensionsOverride, typographyOverride }}>
      <div className="embedded-layout__container">
        <div className={classes.embeddedContent} style={{ padding: 0, overflow: 'hidden' }}>
          {children}
        </div>
      </div>
    </CssBaseDecorator>
  );
}
